<template>
  <v-card>
    <v-flex blue-grey darken-3 white--text>
      <v-card-title primary-title class="py-2">
        <v-icon large left class="white--text">
          {{ data.headers[0].icon }}
        </v-icon>
        <span class="title font-weight-light my-3">
          {{ data.headers[0].text }}</span
        >
        <v-spacer></v-spacer>
        <v-text-field
          v-if="data.data.length > 5"
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          class="my-2 py-0"
          color="white"
          dark
        ></v-text-field>
      </v-card-title>
    </v-flex>
    <v-data-table
      :headers="data.headers"
      :items="data.data"
      :search="search"
      disable-initial-sort
      :rows-per-page-items="[10, 25, 50, 500]"
    >
      <template slot="headers" slot-scope="props">
        <tr d-flex>
          <th
            v-for="(header, idx) in props.headers"
            :key="header.text"
            class="black--text subheading font-weight-bold"
          >
            <span v-if="idx !== 0"
              >{{ header.text }}
              <PopOut v-if="header.helpText" icon="help">{{
                header.helpText
              }}</PopOut></span
            >
          </th>
        </tr>
      </template>
      <template slot="items" slot-scope="props">
        <td class="subheading" :class="{ ['grey lighten-3 font-weight-bold']: props.item.name.startsWith('All ') }">
          {{ props.item.name }}
        </td>
        <td
          class="text-xs-center"
          v-for="header in data.headers.slice(1)"
          :class="{ ['grey lighten-3']: props.item.name.startsWith('All ') }"
          :key="header.name"
        >
          <v-icon v-if="props.item[header.value] === true" color="black"
            >done</v-icon
          >
          <div v-else-if="props.item[header.value]" class="subheading">
            {{ props.item[header.value] }}
          </div>
        </td>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import PopOut from "@bugseq-site/shared/src/components/PopOut";

export default {
  props: {
    data: Object,
    search: "",
  },
  components: {
    PopOut,
  },
};
</script>
